module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/boatFeatured3.webp";